import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { EmojiEvents, Group, Person } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

interface TabItem {
  label: string;
  value: string;
  icon: React.ComponentType;
  path: string;
}

const tabItems: TabItem[] = [
  {
    label: "Zawody",
    value: "contests",
    icon: EmojiEvents,
    path: "/contests",
  },
  {
    label: "Zawodnicy",
    value: "participants",
    icon: Person,
    path: "/participants",
  },
  {
    label: "Grupy",
    value: "groups",
    icon: Group,
    path: "/groups",
  },
];

export default function TabMenu() {
  const location = useLocation();
  const navigate = useNavigate();

  // Określ aktywną zakładkę na podstawie ścieżki
  const getActiveTab = () => {
    const path = location.pathname;
    const tab = tabItems.find((item) => path.startsWith(item.path));
    return tab?.value || "contests";
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    const tab = tabItems.find((item) => item.value === newValue);
    if (tab) {
      navigate(tab.path);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        px: 0, // Usunięto padding
        py: 1, // Dodano mały padding vertical
      }}
    >
      <Tabs
        value={getActiveTab()}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          px: { xs: 2, sm: 3 }, // Padding tylko w Tabs
          minHeight: 48,
          "& .MuiTab-root": {
            minWidth: "auto",
            px: { xs: 2, sm: 3 },
            py: 1.5,
            minHeight: 48,
            fontSize: "0.875rem",
            fontWeight: 500,
            textTransform: "none",
            color: "#6c6c6c",
            "&.Mui-selected": {
              color: "#6366f1",
            },
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#6366f1",
            height: 3,
          },
        }}
      >
        {tabItems.map((item) => (
          <Tab
            key={item.value}
            label={item.label}
            value={item.value}
            icon={<item.icon />}
            iconPosition="start"
          />
        ))}
      </Tabs>
    </Box>
  );
}
